import axios from "axios";
import { removeCookie } from "../../helpers";

export const http = axios.create({
  timeout: 30000,
  baseURL: process.env.API_BASE_URL,
  headers: {
    Accept: "application/json, text/javascript, */*; q=0.01",
    "X-Requested-With": "XMLHttpRequest",
    "cache-control": "no-cache, no-store, must-revalidate",
  },
});

http.interceptors.response.use(
  (response) => {
    const { data } = response;

    if (response.headers && response.headers["Authorization"]) {
      const token = response.headers["Authorization"].split(" ")[1];
      if (token) {
        data.auth = {
          token,
        };
      }
    }
    return Promise.resolve(data);
  },

  async (error) => {
    if (error.response && error.response.status === 401) {
      clearToken();
      removeCookie("access_token");
      removeCookie("refresh_token");
      if (!(window.location.pathname === "/login")) {
        window.location.href = "login";
      }
    }

    if (
      error.response &&
      error.response.status &&
      [400, 401, 409, 422].indexOf(error.response.status) !== -1 &&
      typeof error.response.data !== "undefined"
    ) {
      return Promise.reject(error.response.data);
    }

    return Promise.reject(error.response);
  }
);

export const setToken = (token: string): void => {
  http.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};

export const clearToken = (): void => {
  delete http.defaults.headers.common["Authorization"];
};
